import { Body } from "@/components/standard/BFText"
import {
  AccordionContent,
  AccordionItem,
} from "@/components/reusables/ui/accordion"
import { AccordionHeader } from "@/screens/loans/components/setup/AccordionHeader"
import { DatePickerBasic } from "@/components/input/DatePicker"
import { Container } from "@/screens/rewards/components/Container"

export const DateQuestion = ({
  date,
  defaultValue,
  onChange,
  accordianKey,
  header,
  text,
}: {
  date?: Date
  defaultValue: Date
  onChange: (date?: Date) => void
  accordianKey: string
  header: string
  text: string
}) => {
  return (
    <AccordionItem value={accordianKey}>
      <AccordionHeader
        text={header}
        value={date ? date.toLocaleDateString() : ""}
      />
      <AccordionContent>
        <Body color={"primary"}>{text}</Body>
        <Container className={"mt-2"}>
          <DatePickerBasic
            currentDate={date || defaultValue}
            onChange={onChange}
          />
        </Container>
      </AccordionContent>
    </AccordionItem>
  )
}
